module.exports = __webpack_public_path__ + "img/HorizontalLine.8ffc74c1.svg";